import { useMutation } from "@tanstack/react-query";

import ky from "@/shared/api";
import { Responsible } from "@/shared/types.ts";
import dom from "@/shared/helper/dom.helper.ts";

export function useLabelExports() {
  return useMutation<Responsible<string>, void, { count: number }>({
    mutationFn: ({ count }) =>
      ky
        .post<Responsible<string>>(
          "https://gateway.maguya.kz/api/v1/template/courier/identification/list/qrs",
          {
            json: { count },
            timeout: 60 * 1000,
          },
        )
        .json(),
    onSuccess: ({ data }) => {
      dom.openFileFromBase64(data);
    },
  });
}
